import { MapPin } from 'lucide-react';

interface AuthenticatedMapProps {
  lat: number;
  lng: number;
  zoom?: number;
  width?: number;
  height?: number;
  className?: string;
  alt?: string;
}

export function AuthenticatedMap({
  lat,
  lng,
  zoom = 15,
  height = 200,
  className = '',
}: AuthenticatedMapProps) {
  if (lat == null || lng == null || isNaN(lat) || isNaN(lng)) {
    return (
      <div
        className={`${className} bg-muted flex items-center justify-center text-muted-foreground`}
        style={{ height }}
      >
        <div className="text-center">
          <MapPin className="w-8 h-8 mx-auto mb-1 opacity-50" />
          <div className="text-xs">Map unavailable</div>
        </div>
      </div>
    );
  }

  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined;

  let src: string;
  if (apiKey) {
    src = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${lat},${lng}&zoom=${zoom}`;
  } else {
    const delta = 0.004 / Math.pow(2, zoom - 15);
    const bbox = `${lng - delta},${lat - delta * 1.2},${lng + delta},${lat + delta * 1.2}`;
    src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
  }

  return (
    <iframe
      title="Map location"
      src={src}
      width="100%"
      height={height}
      style={{ border: 0, display: 'block' }}
      className={className}
      loading="lazy"
      allowFullScreen
    />
  );
}
